// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"d4464478","994":"5a790da4"}[chunkId] + ".chunk.js";
};